import { DialogCloseButton } from "@components/_Misc";
import { useState } from "react";
// import { useHistory } from "react-router-dom";

type Opts = {
  /** optionally run any code when onClose() is called (returned from hook).
   * For example, to run a parent's close function - as used in the changelog's create/update modal.
   */
  onClose?: () => void;
};
export const useDialog = (initOpen = false, opts?: Opts) => {
  const [open, setOpen] = useState(initOpen);
  // const history = useHistory();
  // history.push(history.location.pathname)

  const CloseButton = () => <DialogCloseButton onClick={() => setOpen(false)} />;

  const onClose = () => {
    opts?.onClose?.();
    setOpen(false);
  };

  const toggle = () => setOpen((prev) => !prev);

  // useEffect(() => {
  //   if (history.action === "POP" && open) {
  //     setOpen(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [history.action]);

  // const onPopStateRef = useRef(() => closeDialog?.());
  // useEffect(() => {
  //   const onPopState = onPopStateRef.current;
  //   window.addEventListener("popstate", onPopState);
  //   window.history.pushState("forward", "updateitem", "");
  //   return () => {
  //     window.removeEventListener("popstate", onPopState);
  //   };
  // }, []);

  // useEffect(() => {
  //   if (open) history.push(history.location.pathname);
  //   return () => {
  //     if (history.action === "PUSH") {
  //       history.goBack();
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [open]);

  return {
    open,
    toggle,
    setOpen,
    onClose,
    DialogCloseButton: CloseButton,
  };
};
